import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import Landing from "@/pages/Landing";
import Panel from "@/pages/Panel";
import Admin from "@/pages/Admin";
import Checkout from "@/pages/Checkout";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/checkout/:planId" element={<Checkout />} />
            <Route path="/panel/:code" element={<Panel />} />
            <Route path="/panel/:code/:step" element={<Panel />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
